// TOP LEVEL IMPORTS
import React from 'react';
// MODULES
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
import heynedLogo from 'lib/media/heyned-logo.svg';
import Title from 'components/text/Title';

const styles = {
  topBar: {
    height: 55,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#4f5d75',
  },
  navBar: {
    height: 80,
    padding: 3,
    paddingLeft: 17,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#ffff',
  },
};

const NavBar = () => (
  <div style={styles.navBar}>
    <img src={heynedLogo} style={{ maxHeight: 63 }} alt="logo" />
  </div>
);

const TopBar = ({ invoice }) => {
  if (!invoice.due) {
    return null;
  }
  if (invoice.status === 'PAID') {
    return (
      <div style={styles.topBar}>
        <Title style={{ color: '#fff', margin: 0 }}>
          This invoice was paid on {GeneralHelpers.formatDate(invoice.paidAt)}
        </Title>
      </div>
    );
  }
  return (
    <div style={styles.topBar}>
      <Title style={{ color: '#fff', margin: 0 }}>
        This invoice is due on {GeneralHelpers.formatDate(invoice.due)}
      </Title>
    </div>
  );
};

const TopSection = props => (
  <div>
    <NavBar />
    <TopBar {...props} />
  </div>
);

export default TopSection;



// WEBPACK FOOTER //
// ./src/routes/invoice-pay/TopSection/index.js